/* Auto Generated */

export enum ExpertBookingDateType {
	hour,
	morning,
	afternoon,
	fullDay,
}
